import axiosLib from "axios";
import { CHAT_BASE } from "../config/apiPaths";

// ✅ ALWAYS end with a slash.
const WIDGET_KEY = (import.meta?.env?.VITE_WIDGET_KEY) || "";

const api = axiosLib.create({
  baseURL: CHAT_BASE,
  timeout: 15000,
});

function hdr() {
  const h = { "Content-Type": "application/json" };
  if (WIDGET_KEY) h["X-Widget-Key"] = WIDGET_KEY;
  return h;
}

export async function chatHealth() {
  const { data } = await api.get("health/", { headers: hdr() });
  return data;
}

export async function newSession() {
  const { data } = await api.post("session/", {}, { headers: hdr() });
  return data.session_id;
}

export async function sendMessage(params) {
  const cfg = { headers: hdr() };
  try {
    // baseURL already has trailing slash → "" hits "/api/chat/"
    const { data } = await api.post("", params, cfg);
    return data;
  } catch (err) {
    if (!err?.response) {
      const { data } = await api.post("", params, cfg);
      return data;
    }
    throw err;
  }
}

export async function submitMedOpsLeadForm(params) {
  const { data } = await api.post("medops/lead/", params, { headers: hdr() });
  return data;
}

export async function submitPharmaLeadForm(params) {
  const { data } = await api.post("pharma/lead/", params, { headers: hdr() });
  return data;
}

export async function submitQueryForm(params) {
  const { data } = await api.post("query/", params, { headers: hdr() });
  return data;
}
